import React from 'react';
import { platforms } from './constants';

// Calculate totals for platform breakdown
export const calcTotal = (obj) => {
  if (!obj || typeof obj !== 'object') return 0;
  return Object.values(obj).reduce((a, b) => a + (Number(b) || 0), 0);
};

export function PlatformTooltip({ data, type, label, position, hoveredCell }) {
  if (!hoveredCell) return null;
  
  // Filter out platforms with 0 or no data
  const filteredData = Object.entries(data).filter(([_, value]) => value > 0);
  
  if (filteredData.length === 0) return null;
  
  return (
    <div 
      className="fixed z-[9999] bg-[#0a0a0c]/95 backdrop-blur-sm border border-[hsl(var(--border))] rounded-lg p-2.5 shadow-xl"
      style={{ 
        left: `${position.x}px`,
        top: `${position.y + 8}px`,
        boxShadow: '0 10px 30px -5px rgba(0,0,0,0.8)',
      }}
    >
      <div className="flex items-center gap-1.5 mb-2 pb-1.5 border-b border-[hsl(var(--border))]">
        <div className="w-1.5 h-1.5 rounded-full bg-gradient-to-r from-[#E63946] to-[#F97316]" />
        <p className="text-[10px] font-semibold text-white uppercase tracking-wide">{label}</p>
      </div>
      <div className="space-y-1">
        {filteredData.map(([platform, value]) => {
          const config = platforms[platform];
          const IconComponent = config.icon;
          return (
            <div key={platform} className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-1.5">
                <div className="w-5 h-5 rounded flex items-center justify-center" style={{ backgroundColor: `${config.color}25` }}>
                  {typeof IconComponent === 'function' && IconComponent.prototype?.render ? 
                    <IconComponent size={12} style={{ color: config.color }} /> : 
                    <span className="text-[8px] font-bold" style={{ color: config.color }}>{config.shortLabel}</span>
                  }
                </div>
                <span className="text-[11px] text-[#9CA3AF]">{config.shortLabel}</span>
              </div>
              <span className="text-[11px] text-white font-semibold">
                {type === 'currency' ? `RM${value.toLocaleString()}` : value.toLocaleString()}
              </span>
            </div>
          );
        })}
      </div>
      <div className="mt-1.5 pt-1.5 border-t border-[hsl(var(--border))] flex justify-between items-center">
        <span className="text-[10px] text-[#6B7280]">Total</span>
        <span className="text-xs text-white font-bold">
          {type === 'currency' ? `RM${calcTotal(data).toLocaleString()}` : calcTotal(data).toLocaleString()}
        </span>
      </div>
    </div>
  );
}
